var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-targeting-rule',[_c('div',[_vm._v("Visitors who "+_vm._s(_vm.wordMap[_vm.data])+" AdBlock, AdBlock Plus, etc. will show the campaign.")])])}
var staticRenderFns = []

export { render, staticRenderFns }